import { cx } from '@linaria/core';
import { useNotifier } from '@provider/notifier';
import { Button } from '@ui/kit';
import { ComponentFrameworkRetryGraphic, RetryRotatedIcon } from '@ui/kit/icons';
import { graphic, button } from './modal.retry.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { UniversalContextMenuButton } from '../contextmenu/molecule.contextmenu.js';

const retryModalConfig = {
  heading: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ComponentFrameworkRetryGraphic, {
      className: graphic,
      role: "presentation"
    }), /*#__PURE__*/jsx("span", {
      children: "Start forfra"
    })]
  }),
  body: /*#__PURE__*/jsx(Fragment, {
    children: "Vil du slette alt og starte forfra?"
  }),
  labels: {
    ok: "Ja, start forfra",
    cancel: "Nej, tilbage til opgaven"
  }
};
function RetryButton(props) {
  const notifier = useNotifier();
  const handleRetry = async () => {
    props.onClick?.();
    const result = await notifier.confirm(retryModalConfig);
    switch (result) {
      case "ok":
        props.onReset();
        break;
    }
  };
  switch (props.context) {
    case "button":
      return /*#__PURE__*/jsx(Button, {
        className: cx(button, props.className),
        theme: "secondary",
        onClick: handleRetry,
        icon: {
          position: "before",
          content: /*#__PURE__*/jsx(RetryRotatedIcon, {})
        },
        children: "Start forfra"
      });
    case "contextmenu":
      return /*#__PURE__*/jsx(UniversalContextMenuButton, {
        as: "button",
        className: props.className,
        icon: /*#__PURE__*/jsx(RetryRotatedIcon, {}),
        label: "Start forfra",
        onClick: handleRetry
      });
  }
}

export { RetryButton, retryModalConfig };
//# sourceMappingURL=modal.retry.js.map
